var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legend-category",on:{"click":_vm.click}},[_c('div',{staticClass:"legend-icon-container"},[_c('div',{staticClass:"legend-icon"},[_c('v-icon',{style:({ color: _vm.colortheme.color2 })},[_vm._v(_vm._s(_vm.pin.icon))])],1)]),_c('h3',{staticClass:"legend-label"},[_vm._v(_vm._s(_vm.pin.legend_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }